import { _axios } from "interceptor/http-config";

export const _AuthApi = {
  login: async (data) => {
    return _axios.post("/login", data).then((res) => {
      _AuthApi.storeToken(res.data?.data?.access_token);
      _AuthApi.storeIsAdmin(res.data?.data?.is_admin);
    });
  },

  storeToken: (edust_dashboard_token) => {
    localStorage.setItem("edust_dashboard_token", edust_dashboard_token);
  },
  storeIsAdmin: (is_admin) => {
    localStorage.setItem("is_admin", is_admin);
  },

  getToken: () => localStorage.getItem("edust_dashboard_token"),
  getIsAdmin: () => localStorage.getItem("is_admin"),

  destroyToken: () => {
    localStorage.removeItem("edust_dashboard_token");
    localStorage.removeItem("is_admin");
    window.location.reload();
  },

  sendCode: async (data) => {
    return _axios.post("/send-code", data);
  },
  verifyCode: async (data, config) => {
    return _axios.post("/check-code", data, {
      headers: config.headers,
    });
  },
  resetPassword: async (data) => {
    return _axios.post("/reset-password", data);
  },
  resendCode: async (data) => {
    return _axios.post("/resend_code", data);
  },
  updateProfile: async (formData) => {
    return _axios.post("/admins/profile", formData);
  },
};
